// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fond full width noir (var index.css) */
.footerWrap {
  background: var(--couleur-dark);
  padding: 22px 0;
  font-family: "DM Sans", sans-serif;
}

.footerInner {
  background: var(--couleur-dark);
  padding: 0;
}

/* ===== TOP GRID ===== */
.topGrid {
  display: grid;
  grid-template-columns: 360px 1fr 360px;
  gap: 44px;
  align-items: start;
  padding: 10px 0 12px;
}

/* ===== LEFT : Logo + paiements ===== */
.leftBlock {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Logo image (on garde votre logique) */
.logo {
  width: 30%;
  height: auto;
  display: block;
  object-fit: contain;

  margin-top: -50px;
  margin-left: -6px;
  margin-bottom: -10px;
}

/* Paiements 2x2 */
.payments {
  display: grid;
  grid-template-columns: repeat(2, max-content);
  column-gap: 46px;
  row-gap: 18px;
  align-items: center;
}

/* Base */
.payIcon {
  display: block;
  object-fit: contain;
  opacity: 1;
}

/* Tailles Figma (par icône) */
.payIcon--visa {
  width: 84px;
  height: 27px;
}

.payIcon--mvola {
  width: 104px;
  height: 51px;
}

.payIcon--orange {
  width: 100px;
  height: 59px;
}

.payIcon--airtel {
  width: 113px;
  height: 37px;
}

/* ===== ALIGNEMENT “même ligne” que les paiements ===== */
.siteMap,
.rightBlock {
  margin-top: 42px;
}

/* ===== TITRES (Figma : 20 / SemiBold / DM Sans) ===== */
.title {
  color: var(--white-principale);

  font-family: "DM Sans", sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0;

  margin: 0 0 14px 0;
}

/* ===== SITE MAP ===== */
.linksGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 34px;
}

.linkList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Liens */
.link {
  /* gris provenant de vos variables */
  color: var(--white-rgba);
  text-decoration: none;

  font-family: "DM Sans", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0;
}

.link:hover {
  color: var(--white-principale);
}

/* ===== RIGHT : FOLLOW + CALL côte à côte ===== */
.rightBlock {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 22px;
  align-items: start;
}

/* FOLLOW US */
.socials {
  display: flex;
  gap: 10px;
}

/* Taille Figma icônes socials : 35x35 */
.socialBtn {
  width: 35px;
  height: 35px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  border: none;
  background: transparent;
  padding: 0;
}

/* Les images */
.socialIcon {
  width: 35px;
  height: 35px;
  object-fit: contain;
  display: block;
}

/* Facebook en blanc (marche sur PNG/SVG foncé) */
.socialIcon--white {
  filter: brightness(0) invert(1);
}

/* CALL US */
.callRow {
  display: flex;
  align-items: center;
}

.phone {
  color: var(--white-principale);
  text-decoration: none;

  font-family: "DM Sans", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0;

  white-space: nowrap;
}

/* ===== DIVIDER ===== */
/* Si vous voulez garder le trait blanc fort : */
.divider {
  border: 1px solid var(--white-principale);
  height: 5px;
  margin: 14px 0;
  background: var(--white-principale);
}

/* ===== BOTTOM ROW ===== */
.bottomRow {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 8px 0 4px;
}

/* Texte bas (gris via variables) */
.copy {
  color: var(--white-rgba);
  font-size: 13px;
  justify-self: start;
  font-weight: bold;
}

/* Liens légaux */
.legal {
  display: flex;
  gap: 22px;
  justify-self: center;
}

.legalLink {
  color: var(--white-rgba);
  text-decoration: none;
  font-size: 11px;
  letter-spacing: .08em;
  font-weight: 700;
}

.legalLink:hover {
  color: var(--white-principale);
}

/* ===== Responsive ===== */
@media (max-width: 1025px) {
  .topGrid {
    grid-template-columns: 1fr;
    gap: 18px;
    justify-items: center;
    text-align: center;
  }

  .siteMap,
  .rightBlock {
    margin-top: 0;
  }

  .leftBlock {
    align-items: center;
  }

  .logo {
    margin-left: 0;
  }

  .payments {
    justify-content: center;
    justify-items: center;
  }

  .linksGrid {
    justify-content: center;
    justify-items: center;
  }

  .rightBlock {
    grid-template-columns: 1fr;
    row-gap: 14px;
    justify-items: center;
  }

  .socials {
    justify-content: center;
  }

  .callRow {
    justify-content: center;
  }

  .bottomRow {
    grid-template-columns: 1fr;
    gap: 10px;
    justify-items: center;
    text-align: center;
  }

  .copy {
    justify-self: center;
    font-weight: bold;
  }

  .legal {
    justify-self: center;
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 8px;
  }
}

@media (max-width: 520px) {
  .linksGrid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/footer/Footer.css"],"names":[],"mappings":"AAEA,yCAAyC;AACzC;EACE,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,mBAAmB;;EAEnB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,6CAA6C;EAC7C,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,0DAA0D;AAC1D;;EAEE,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,8BAA8B;;EAE9B,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;;EAEjB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,UAAU;AACV;EACE,oCAAoC;EACpC,wBAAwB;EACxB,qBAAqB;;EAErB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;;EAErB,YAAY;EACZ,uBAAuB;EACvB,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;;EAErB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;;EAEjB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB,gDAAgD;AAChD;EACE,yCAAyC;EACzC,WAAW;EACX,cAAc;EACd,mCAAmC;AACrC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;600&display=swap');\n\n/* Fond full width noir (var index.css) */\n.footerWrap {\n  background: var(--couleur-dark);\n  padding: 22px 0;\n  font-family: \"DM Sans\", sans-serif;\n}\n\n.footerInner {\n  background: var(--couleur-dark);\n  padding: 0;\n}\n\n/* ===== TOP GRID ===== */\n.topGrid {\n  display: grid;\n  grid-template-columns: 360px 1fr 360px;\n  gap: 44px;\n  align-items: start;\n  padding: 10px 0 12px;\n}\n\n/* ===== LEFT : Logo + paiements ===== */\n.leftBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Logo image (on garde votre logique) */\n.logo {\n  width: 30%;\n  height: auto;\n  display: block;\n  object-fit: contain;\n\n  margin-top: -50px;\n  margin-left: -6px;\n  margin-bottom: -10px;\n}\n\n/* Paiements 2x2 */\n.payments {\n  display: grid;\n  grid-template-columns: repeat(2, max-content);\n  column-gap: 46px;\n  row-gap: 18px;\n  align-items: center;\n}\n\n/* Base */\n.payIcon {\n  display: block;\n  object-fit: contain;\n  opacity: 1;\n}\n\n/* Tailles Figma (par icône) */\n.payIcon--visa {\n  width: 84px;\n  height: 27px;\n}\n\n.payIcon--mvola {\n  width: 104px;\n  height: 51px;\n}\n\n.payIcon--orange {\n  width: 100px;\n  height: 59px;\n}\n\n.payIcon--airtel {\n  width: 113px;\n  height: 37px;\n}\n\n/* ===== ALIGNEMENT “même ligne” que les paiements ===== */\n.siteMap,\n.rightBlock {\n  margin-top: 42px;\n}\n\n/* ===== TITRES (Figma : 20 / SemiBold / DM Sans) ===== */\n.title {\n  color: var(--white-principale);\n\n  font-family: \"DM Sans\", sans-serif;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 100%;\n  letter-spacing: 0;\n\n  margin: 0 0 14px 0;\n}\n\n/* ===== SITE MAP ===== */\n.linksGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 34px;\n}\n\n.linkList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Liens */\n.link {\n  /* gris provenant de vos variables */\n  color: var(--white-rgba);\n  text-decoration: none;\n\n  font-family: \"DM Sans\", sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0;\n}\n\n.link:hover {\n  color: var(--white-principale);\n}\n\n/* ===== RIGHT : FOLLOW + CALL côte à côte ===== */\n.rightBlock {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 22px;\n  align-items: start;\n}\n\n/* FOLLOW US */\n.socials {\n  display: flex;\n  gap: 10px;\n}\n\n/* Taille Figma icônes socials : 35x35 */\n.socialBtn {\n  width: 35px;\n  height: 35px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n\n  border: none;\n  background: transparent;\n  padding: 0;\n}\n\n/* Les images */\n.socialIcon {\n  width: 35px;\n  height: 35px;\n  object-fit: contain;\n  display: block;\n}\n\n/* Facebook en blanc (marche sur PNG/SVG foncé) */\n.socialIcon--white {\n  filter: brightness(0) invert(1);\n}\n\n/* CALL US */\n.callRow {\n  display: flex;\n  align-items: center;\n}\n\n.phone {\n  color: var(--white-principale);\n  text-decoration: none;\n\n  font-family: \"DM Sans\", sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0;\n\n  white-space: nowrap;\n}\n\n/* ===== DIVIDER ===== */\n/* Si vous voulez garder le trait blanc fort : */\n.divider {\n  border: 1px solid var(--white-principale);\n  height: 5px;\n  margin: 14px 0;\n  background: var(--white-principale);\n}\n\n/* ===== BOTTOM ROW ===== */\n.bottomRow {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  padding: 8px 0 4px;\n}\n\n/* Texte bas (gris via variables) */\n.copy {\n  color: var(--white-rgba);\n  font-size: 13px;\n  justify-self: start;\n  font-weight: bold;\n}\n\n/* Liens légaux */\n.legal {\n  display: flex;\n  gap: 22px;\n  justify-self: center;\n}\n\n.legalLink {\n  color: var(--white-rgba);\n  text-decoration: none;\n  font-size: 11px;\n  letter-spacing: .08em;\n  font-weight: 700;\n}\n\n.legalLink:hover {\n  color: var(--white-principale);\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 1025px) {\n  .topGrid {\n    grid-template-columns: 1fr;\n    gap: 18px;\n    justify-items: center;\n    text-align: center;\n  }\n\n  .siteMap,\n  .rightBlock {\n    margin-top: 0;\n  }\n\n  .leftBlock {\n    align-items: center;\n  }\n\n  .logo {\n    margin-left: 0;\n  }\n\n  .payments {\n    justify-content: center;\n    justify-items: center;\n  }\n\n  .linksGrid {\n    justify-content: center;\n    justify-items: center;\n  }\n\n  .rightBlock {\n    grid-template-columns: 1fr;\n    row-gap: 14px;\n    justify-items: center;\n  }\n\n  .socials {\n    justify-content: center;\n  }\n\n  .callRow {\n    justify-content: center;\n  }\n\n  .bottomRow {\n    grid-template-columns: 1fr;\n    gap: 10px;\n    justify-items: center;\n    text-align: center;\n  }\n\n  .copy {\n    justify-self: center;\n    font-weight: bold;\n  }\n\n  .legal {\n    justify-self: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    row-gap: 8px;\n  }\n}\n\n@media (max-width: 520px) {\n  .linksGrid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
